if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.setProductImage(this.dataset.productImage);
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    setProductImage(productImage) {
      const image = this.querySelector('.added-notification__image');
      if (!image || !productImage) return;

      image.addEventListener('error', () => {
        image.hidden = true;
      }, { once: true });

      image.src = productImage;
      image.hidden = false;
    }

    display() {
      setTimeout(() => {
        this.classList.remove('added-notification--hidden');
      }, 10);

      this.delayedDismissTimeout = setTimeout(
        this.dismiss.bind(this),
        6000
      );

      this.querySelector('.added-notification__close')
        .addEventListener('click', this.dismiss.bind(this));

      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll(
          '.added-notification__cart-button, .added-notification__message-text a[href$="/cart"]'
        );

        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            const drawer = document.querySelector('.js-cart-drawer');
            if (!drawer) return;

            evt.preventDefault();
            drawer.open();
            this.dismiss();
          });
        });
      }
    }

    dismiss(evt) {
      if (evt) evt.preventDefault();
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}